<div>
    <div class="row mb-2">
        <div class="col">
            <div widget class="card border-0 box-shadow">
                <div class="card-body">
                    <!-- Client -->
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="row">
                                <div class="col-lg-2">
                                    <label>Client<sup class="super-script">*</sup></label>
                                </div>
                                <div class="col-lg-7">
                                    <ng-select [searchable]="true" [clearable]="true" bindLabel="Value" bindValue="Key"
                                        [items]="EditScheduleInputProperty.ClientDropdown" [(ngModel)]="EditClientId"
                                        (ngModelChange)="getAuthDetails();getActiveClientRelationshipEmployeeList();getClientWeekStartAndWeekEnd()">
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6"
                            *ngIf="EditClientId!=null && EditClientId!=undefined && EditClientId!='00000000-0000-0000-0000-000000000000'">
                            <div class="row">
                                <div class="col-lg-4">
                                    <label class="label-bold">Location:</label>{{this.clientDetails.clientLocation}}

                                </div>
                                <div class="col-lg-4">
                                    <label class="label-bold">WeekStart:</label>{{this.clientDetails.weekStart}}



                                </div>
                                <div class="col-lg-4">
                                    <label class="label-bold">WeekEnd:</label>{{this.clientDetails.weekEnd}}



                                </div>

                            </div>
                        </div>
                    </div>
                    <!-- Authorization  Details-->
                    <div class="row mt-3"
                        *ngIf="EditClientId!=null && EditClientId!=undefined && EditClientId!='00000000-0000-0000-0000-000000000000'">
                        <div class="col-lg-9 col-sm-12 col-md-12 mb-2">
                            <button class="btn blue-btn btn-sm " (click)="AddClientAuthorization('new','')">Add New
                                Authorization</button>
                        </div>
                        <div class="col-lg-12 ">
                            <div class="control-section">
                                <ejs-grid #gridAuthDetails [dataSource]='AuthorizationDetails' [allowResizing]='true'
                                    [allowSorting]='false' allowPaging='true' [allowFiltering]='false'
                                    [pageSettings]='initialPage' [showColumnChooser]='true'>
                                    <e-columns>
                                        <!-- Action -->
                                        <e-column headerText="Actions" uid="action" textAlign="center"
                                            [showInColumnChooser]='false' width=100>
                                            <ng-template #template let-data>
                                                <button class="btn btn-edit-table"
                                                    (click)="AddClientAuthorization('edit',data)"><i
                                                        class="fa fa-edit"></i></button>
                                            </ng-template>
                                        </e-column>
                                        <!-- Start Date -->
                                        <e-column field="startDate" headerText="Start Date" width=150 textAlign='center'
                                            [allowEditing]='false' type='date' [format]='formatOptions'>
                                        </e-column>
                                        <!-- End Date -->
                                        <e-column field='endDate' headerText='End Date' width=150 textAlign='left'
                                            [allowEditing]='false' type='date' [format]='formatOptions'>
                                        </e-column>
                                        <!-- Service -->
                                        <e-column field='serviceCode' headerText='Service' width=100 textAlign='center'
                                            [allowEditing]='false' type='string'>
                                        </e-column>
                                        <!-- Service Agreement# -->
                                        <!-- <e-column field='serviceAgreementNumber' headerText='Service Agreement' width=100
                                            textAlign='center' [allowEditing]='false' type='string'>
                                        </e-column> -->
                                        <!-- Insurance Number#-->
                                        <!-- Insurance Number#-->
                                        <e-column field='insuranceNumber' headerText='Insurance No' width=100
                                            textAlign='center' [allowEditing]='false' type='string'>
                                        </e-column>
                                        <!-- Total Amount -->
                                        <e-column field='totalAmt' headerText='Total Amount' width=100
                                            textAlign='center' [allowEditing]='false' type='number'>
                                        </e-column>
                                        <!-- Payer Name	 -->
                                        <e-column field='payorName' headerText='Payer Name' width=100 textAlign='center'
                                            [allowEditing]='false' type='string'>
                                        </e-column>
                                        <!-- Total Hours  -->
                                        <e-column field='totalhours' headerText='Payer Name' width=100
                                            textAlign='center' [allowEditing]='false' type='string'>
                                        </e-column>
                                        <!-- Remaining Amount -->
                                        <e-column field='remainingAmt' headerText='Remaining Amount' width=100
                                            textAlign='center' [allowEditing]='false' type='string'>
                                        </e-column>
                                        <!--Hours/day -->
                                        <!-- <e-column headerText="Hours/day" textAlign="center"
                                            [showInColumnChooser]='false' width=100>
                                            <ng-template #template let-data>
                                                <label> {{data.unithr }} hrs {{data.unitmin}} mins</label>
                                            </ng-template>
                                        </e-column> -->
                                        <!-- Company Name	 -->
                                        <e-column field='companyName' headerText='Company Name' width=100
                                            textAlign='center' [allowEditing]='false' type='string'>
                                        </e-column>
                                        <!-- Remaining hours per day -->
                                        <!-- <e-column headerText="Remaining hours per day" field="remainunitperDay"
                                            textAlign="center" [showInColumnChooser]='false' width=150>
                                        </e-column> -->
                                    </e-columns>
                                </ejs-grid>
                                <div *ngIf="AuthorizationDetails.length==0" class="text-center" style="color:red">
                                    <p>No data available</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2 mb-2"
                        *ngIf="EditClientId!=null && EditClientId!=undefined && EditClientId!='00000000-0000-0000-0000-000000000000'">
                        <div class="col-lg-12" *ngFor="let Appointment of AppointmentArrayList;let INDEX=index">
                            <div class="card">
                                <div class="row  card-header card-show ms-0 me-0 transparent text-muted">
                                    <div class="col-lg-8">
                                        <h5 class="mb-0">
                                            <a style="color:#004290">
                                                Schedule
                                            </a>
                                        </h5>
                                    </div>
                                    <div class="col-lg-3 text-right ">

                                        <i class="fa fa-plus-circle  text-primary" aria-hidden="true"
                                            style="font-size: 22px;" (click)="AddAppointment()"></i>
                                        <i class="fa fa-minus-circle ms-2 text-danger"
                                            (click)="removeAppointment(INDEX)" style="font-size: 22px;"></i>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div>
                                            <div class="card-body">
                                                <!-- Employee ,Service Group-->
                                                <div class="row">
                                                    <div class="col-lg-6">
                                                        <div class="col-lg-12">
                                                            <label style="font-weight:bold">Employee <sup
                                                                    class="super-script">*</sup></label>
                                                        </div>
                                                        <div class="col-lg-12 d-flex">
                                                            <ng-select [searchable]="true" class="w-100"
                                                                [clearable]="true" bindLabel="name" bindValue="id"
                                                                [(ngModel)]="Appointment.employeeId"
                                                                [items]="EmployeeDropdown"
                                                                (ngModelChange)="getClientServiceDropdown(Appointment)">
                                                            </ng-select>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <div class="col-lg-12">
                                                            <label style="font-weight:bold">Service Group <sup
                                                                    class="super-script">*</sup></label>
                                                        </div>
                                                        <div class="col-lg-12 d-flex">
                                                            <ng-select [searchable]="true" class="w-100" [disabled]="Appointment.employeeId=='00000000-0000-0000-0000-000000000000' || Appointment.employeeId==null ||
                                                            Appointment.employeeId==undefined" [clearable]="true"
                                                                bindLabel="serviceGroupName" bindValue="serviceGroupId"
                                                                [(ngModel)]="Appointment.serviceGroupId"
                                                                [items]="Appointment.serviceGroup"
                                                                (ngModelChange)="getServiceList(Appointment.serviceGroupId)">
                                                            </ng-select>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <div class="col-lg-12">
                                                            <label style="font-weight:bold">Service<sup
                                                                    class="super-script">*</sup></label>
                                                        </div>
                                                        <div class="col-lg-12 d-flex">
                                                            <ng-select [searchable]="true" class="w-100" [disabled]="Appointment.serviceGroupId=='00000000-0000-0000-0000-000000000000' || Appointment.serviceGroupId==null ||
                                                            Appointment.serviceGroupId==undefined" [clearable]="true"
                                                                bindLabel="serviceName" bindValue="serviceId"
                                                                [(ngModel)]="Appointment.serviceId"
                                                                [items]="serviceList">
                                                            </ng-select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- Start Date,End Date,Start Time,End Time -->
                                                <div class="row">
                                                    <div class="col-lg-3">
                                                        <div class="col-lg-12">
                                                            <label style="font-weight:bold">Start Date <sup
                                                                    class="super-script">*</sup></label>
                                                        </div>
                                                        <div class="col-lg-12 ">
                                                            <my-date-picker [selDate]="Appointment.startDate"
                                                                placeholder="mm/dd/yyyy" [options]="PastandFutureOption"
                                                                (inputFieldChanged)="Schedulenewdates($event,'inputchanged','EditStart',INDEX)"
                                                                (dateChanged)="Schedulenewdates($event,'datechanged','EditStart',INDEX)">
                                                            </my-date-picker>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <div class="col-lg-12">
                                                            <label style="font-weight:bold">End Date <sup
                                                                    class="super-script">*</sup></label>
                                                        </div>
                                                        <div class="col-lg-12 ">
                                                            <my-date-picker [selDate]="Appointment.endDate"
                                                                placeholder="mm/dd/yyyy" [options]="PastandFutureOption"
                                                                (inputFieldChanged)="Schedulenewdates($event,'inputchanged','EditEnd',INDEX)"
                                                                (dateChanged)="Schedulenewdates($event,'datechanged','EditEnd',INDEX)">
                                                            </my-date-picker>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <div class="col-lg-12">
                                                            <label style="font-weight:bold">Start Time <sup
                                                                    class="super-script">*</sup></label>
                                                        </div>
                                                        <div class="col-lg-12 ">
                                                            <input type="time" [(ngModel)]="Appointment.startTime"
                                                                [disabled]="Appointment.startDate==null||
                                                            Appointment.startDate==undefined || Appointment.startDate==''"
                                                                class="form-control" />
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <div class="col-lg-12">
                                                            <label style="font-weight:bold">End Time <sup
                                                                    class="super-script">*</sup></label>
                                                        </div>
                                                        <div class="col-lg-12 ">
                                                            <input type="time" [(ngModel)]="Appointment.endTime"
                                                                [disabled]="Appointment.endDate==null||
                                                            Appointment.endDate==undefined || Appointment.endDate==''"
                                                                class="form-control" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- Custom Frequency,Frequency Days, -->
                                                <div class="row">
                                                    <div class="col-lg-3">
                                                        <label style="font-weight:bold">Custom Frequency <sup
                                                                class="super-script">*</sup></label>
                                                        <ng-select [searchable]="true" class="w-100" [clearable]="true"
                                                            bindLabel="lovName" bindValue="id"
                                                            [items]="EditScheduleInputProperty.CustomFrequencyList"
                                                            [(ngModel)]="Appointment.customFrequencyLid"
                                                            (ngModelChange)="checkCustomFrequencyType(Appointment.customFrequencyLid,INDEX)">
                                                        </ng-select>
                                                    </div>
                                                    <div class="col-lg-9 pt-4" *ngIf="Appointment.showDays">
                                                        <label style="font-weight:bold"></label>
                                                        <ng-container
                                                            *ngFor="let FD of Appointment.FrequencyDays;let i=index">

                                                            <input type="checkbox" [(ngModel)]="FD.ischecked">
                                                            <label class="ms-2 mt-2"
                                                                [style.font-weight]="FD.ischecked==true? '700' : '400'">{{FD.Key}}</label>&nbsp;

                                                        </ng-container>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Save & Close or Update & Close -->
                    <div class="float-end">
                        <button class="btn btn-sm blue-btn" (click)="
                        checkScheduleValidation()"
                            [disabled]="EditClientId==null || EditClientId==undefined ||EditClientId=='00000000-0000-0000-0000-000000000000'">
                            <span>Save & Close</span>
                        </button>&nbsp;&nbsp;
                        <button class="btn btn-sm blue-btn" (click)="CloseSchedule()">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!------------------------------client Authorization--------------------------------------------------------------->
<app-client-authorization (EventToEditAuth)="dataEmitfromChildAuth($event)" *ngIf="EditAuthorization"
    [DataFromAuthorizationList]="AuthorizationInputDetails">
</app-client-authorization>

  
   
